import { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

interface ClaimsIdentity {
  name: string;
  preferred_username: string;
  family_name: string;
  given_name: string;
}

export interface Identity {
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
}

const isValidIdentity = (identity: object | undefined): identity is ClaimsIdentity => {
  if (identity === undefined) return false;

  const claimsIdentity = identity as ClaimsIdentity;
  return [claimsIdentity.name, claimsIdentity.preferred_username].every((key) => typeof key === "string");
};

const getIdentityFromAccount = (account: AccountInfo | null) =>
  isValidIdentity(account?.idTokenClaims) ? account?.idTokenClaims : undefined;

const useIdentity = (): Identity | undefined => {
  const { instance } = useMsal();
  let account = instance.getActiveAccount();
  const accounts = instance.getAllAccounts();

  // Set active account if not already set and exactly one account is available
  if (!account && accounts.length) {
    account = accounts[0]!;
    instance.setActiveAccount(account);
  }

  const identity = getIdentityFromAccount(account);

  return identity
    ? {
        fullName: identity.name,
        firstName: identity.given_name,
        lastName: identity.family_name,
        email: identity.preferred_username,
      }
    : undefined;
};

export default useIdentity;
